// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBroccoli = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M16 7.3c0 .9-.298 1.731-.8 2.4h2.3q.131-.297.229-.61A3.001 3.001 0 0117 15v2a5 5 0 00.997-9.9 6 6 0 00-11.994 0A5.002 5.002 0 007 17v-2a3 3 0 01-.729-5.91q.098.313.228.61h2.3A4 4 0 1116 7.3" />,
    <path d="M7 13c.465 0 .966.056 1.336.292.285.183.664.58.664 1.708v7h6v-7c0-.465.056-.966.292-1.336.183-.285.58-.664 1.708-.664v-2c-1.673 0-2.774.62-3.392 1.586-.563.88-.608 1.879-.608 2.414v5h-2v-5c0-1.673-.62-2.774-1.586-3.392C8.534 11.045 7.535 11 7 11z" />
  );
export default SvgIconBroccoli;
